import { render } from "./FaseExib.vue?vue&type=template&id=34184a4b&scoped=true"
import script from "./FaseExib.vue?vue&type=script&lang=js"
export * from "./FaseExib.vue?vue&type=script&lang=js"

import "./FaseExib.vue?vue&type=style&index=0&id=34184a4b&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-34184a4b"]])

export default __exports__